import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormDatosCanonicos extends Component {
  constructor(props) {
    super(props);
    this.setInformacionOrganismo = this.setInformacionOrganismo.bind(this);
  }

  // Función que hace el put a los datos personales de la monja
  async setInformacionOrganismo(event) {
    event.preventDefault();
    let $this = $(this);
    //Formdata coge todo los elementos del formulario
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/provincias/" + $this[0].props.DatosProvincia.id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito los asigna al estado del componente monja detalle
    await $.ajax(settings)
      .done(async function (response) {
        response = JSON.parse(response);
        $this[0].props.setInformacionOrganismo(response);
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
      })

      .fail($this[0].props.ErrorHandling);
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();
    return (
      <Form className=" p-4" onSubmit={this.setInformacionOrganismo} id="MyForm" autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Nombre *</Form.Label>
          <Form.Control required type="text" name="name" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosProvincia.name} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Clave *</Form.Label>
          <Form.Control required type="text" name="key" maxLength="5" autoComplete="nope" defaultValue={this.props.DatosProvincia.key} />
        </Form.Group>

        <Form.Group>
          <Form.Label>Número *</Form.Label>
          <Form.Control required type="number" name="companyNumber" max="999999" autoComplete="nope" defaultValue={this.props.DatosProvincia.companyNumber} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Fecha de Creación *</Form.Label>
          <Form.Control required type="date" name="startDate" max={today} autoComplete="nope" defaultValue={this.props.DatosProvincia.startDate} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Fecha de Supresión</Form.Label>
          <Form.Control type="date" name="endDate" max={today} autoComplete="nope" defaultValue={this.props.DatosProvincia.endDate} />
        </Form.Group>
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Datos Canonicos"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
